import { render } from "./Batch.vue?vue&type=template&id=9567a996&scoped=true"
import script from "./Batch.vue?vue&type=script&lang=js"
export * from "./Batch.vue?vue&type=script&lang=js"

import "./Batch.vue?vue&type=style&index=0&id=9567a996&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9567a996"]])

export default __exports__